import { Button, Paper } from '@material-ui/core'
import React from 'react'
import { inlineStyles } from '../styles/CustomStyles'
import { logoutKeycloak } from '../keycloak'

const Unauthorized = props => {
  function logout () {
    // props.history.push('/')
    logoutKeycloak()
  }
  const { message } = props
  if(message === undefined){
    message = "You are not authorized to use CAD module, please check your credentials."
  }

  return (
    <Paper
      elevation={7}
      style={{ padding: '40px', margin: 'auto auto', width: '50%' }}
    >
      <div>
        <span style={{ color: 'red', fontSize: '24px' }}>
          {message}
        </span>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Button
            variant='contained'
            color='primary'
            style={{
              ...inlineStyles.normalButton
            }}
            onClick={logout}
          >
            Log out
          </Button>
        </div>
      </div>
    </Paper>
  )
}

export default Unauthorized
